export enum EValidator {
    DocValidator = 'docValidator',
    EntityContextValidator = 'entityContextValidator',
    DummyValidator = 'dummyValidator',
    DocMetaFileNameValidator = 'FileNameMetadataInputValidator',
    DocFileSizeValidator = 'DocFileSizeValidator',
}
